import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { usePenStatus } from "../nativebridge/PenStatus";
import {
  APP_TOAST_CONTAINER_ID,
  useToast,
} from "./useToast";
import { applyPendingPokoroProfileReturnOnPokoroSetting } from "../common/pokoroProfileReturnFlow";

const APPLY_PATHS = new Set(["/pokoroSetting", "/setting"]);

/**
 * 앱 전역 ToastContainer + useToast의 containerId와 연동.
 * 부가: 포코로 설정 프로필 완료 후 /setting·/pokoroSetting 진입 시
 *       localStorage에 쌓인 토스트·연결 해제만 applyPending... 에서 처리.
 */
export default function GlobalToastHost() {
  const { pathname } = useLocation();
  const { showSuccessToast } = useToast();
  const { setGlobalPenStatus } = usePenStatus();

  useEffect(() => {
    if (!APPLY_PATHS.has(pathname)) {
      return undefined;
    }
    const timer = window.setTimeout(() => {
      applyPendingPokoroProfileReturnOnPokoroSetting({
        showSuccessToast,
        setGlobalPenStatus,
      });
    }, 150);
    return () => window.clearTimeout(timer);
  }, [pathname, showSuccessToast, setGlobalPenStatus]);

  return (
    <ToastContainer
      containerId={APP_TOAST_CONTAINER_ID}
      position="bottom-center"
      limit={3}
      newestOnTop={false}
      closeButton={false}
      hideProgressBar
      rtl={false}
      pauseOnFocusLoss
      draggable
      theme="colored"
    />
  );
}
